<template>
  <StModal size="medium" :on-close="() => emit(CLOSE)">
    <div class="st-change-subscription-modal">
      <StHeadline :level="2">Ändra abonnemang</StHeadline>

      <dl class="st-change-subscription-modal__details">
        <dt>Organisationsnummer:</dt>
        <dd>{{ organizationNumber }}</dd>
        <dt>Erbjudandenamn:</dt>
        <dd>{{ offerName }}</dd>
      </dl>

      <StFormGroup label="Tillåt abonnemang" required>
        <StSelect
          v-model="selectedSubscription"
          :items="subscriptionOptions"
          :has-empty="false"
          required
        />
      </StFormGroup>

      <div class="st-change-subscription-modal__buttons">
        <StButton rectangular secondary full-width @click="emit(CLOSE)">
          Avbryt
        </StButton>
        <StButton
          rectangular
          full-width
          :is-loading="isLoading"
          @click="saveSubscription"
        >
          Spara
        </StButton>
      </div>

      <StError v-if="errorMessage" :error-message="errorMessage" />
    </div>
  </StModal>
</template>

<script setup>
import {
  StButton,
  StError,
  StFormGroup,
  StHeadline,
  StModal,
  StSelect,
} from "skanetrafiken";
import { CLOSE } from "@/constants";
import { ref, watch } from "vue";

const emit = defineEmits(["close", "save"]);
const props = defineProps({
  organizationNumber: {
    type: String,
    required: true,
  },
  offerName: {
    type: String,
    required: true,
  },
  subscription: Boolean,
  isLoading: Boolean,
  errorMessage: String,
});

const subscriptionOptions = [
  { id: "true", name: "Ja" },
  { id: "false", name: "Nej" },
];
const selectedSubscription = ref(String(props.subscription));

watch(
  () => props.subscription,
  (subscription) => {
    selectedSubscription.value = String(subscription);
  },
);

const saveSubscription = () => {
  if (props.subscription.toString() === selectedSubscription.value.toString()) {
    emit(CLOSE);
  } else {
    emit("save", selectedSubscription.value === "true");
  }
};
</script>

<style scoped lang="scss">
@import "~skanetrafiken/dist/scss/main.scss";

.st-change-subscription-modal {
  width: min(rem-calc(450), 100%);

  & > :not(:last-child) {
    margin-bottom: rem-calc(24);
  }

  &__details {
    display: grid;
    grid-template-columns: max-content 1fr;
    gap: rem-calc(12) rem-calc(24);

    dd {
      font-weight: var(--font-weight-semi-bold);
    }
  }

  &__buttons {
    display: flex;
    gap: rem-calc(16);
  }
}
</style>
